import { BsArrowRight } from "react-icons/bs";

import { ExternalLink, InternalLink, Line, OnClickLink, P } from "@sorcery/ui";

import { ModalTypeEnum, useModal } from "~/providers/ModalProvider";
import { collectionGuidePath, collectionPath, faqsPath } from "~/utils/paths";

export const UserResources = ({
  showLines = true,
}: {
  showLines?: boolean;
}) => {
  const { openModal } = useModal();
  return (
    <div className="mb-6 whitespace-nowrap">
      <InternalLink target="_blank" href={faqsPath}>
        <P className="hover:text-primary !mb-0 transition-colors">
          <BsArrowRight size={12} className="mr-2 inline" />
          <span>&nbsp;Full FAQs</span>
        </P>
      </InternalLink>
      <ExternalLink
        target="_blank"
        href="https://drive.google.com/file/d/1sgQo0xf0N2teIR0zlyl91g9j6LVncZnr/view"
      >
        <P className="hover:text-primary !mb-0 transition-colors">
          <BsArrowRight size={12} className="mr-2 inline" />
          <span>&nbsp;Rulebook</span>
        </P>
      </ExternalLink>

      {showLines && <Line className="my-3" />}

      <ExternalLink target="_blank" href="https://sorcerytcg.com/news">
        <P className="hover:text-primary !mb-0 transition-colors">
          <BsArrowRight size={12} className="mr-2 inline" />
          <span>&nbsp;News & Articles</span>
        </P>
      </ExternalLink>
      <ExternalLink target="_blank" href="https://sorcerytcg.com/locator">
        <P className="hover:text-primary !mb-0 transition-colors">
          <BsArrowRight size={12} className="mr-2 inline" />
          <span>&nbsp;Store Locator</span>
        </P>
      </ExternalLink>
      <ExternalLink target="_blank" href="https://play.sorcerytcg.com">
        <P className="hover:text-primary !mb-0 transition-colors">
          <BsArrowRight size={12} className="mr-2 inline" />
          <span>&nbsp;Play Network</span>
        </P>
      </ExternalLink>
      <ExternalLink target="_blank" href="https://discord.gg/mWFU7WK5rm">
        <P className="hover:text-primary !mb-0 transition-colors">
          <BsArrowRight size={12} className="mr-2 inline" />
          <span>&nbsp;Discord Group</span>
        </P>
      </ExternalLink>
      <ExternalLink target="_blank" href="https://www.facebook.com/groups/571474468278149">
        <P className="hover:text-primary !mb-0 transition-colors">
          <BsArrowRight size={12} className="mr-2 inline" />
          <span>&nbsp;Facebook Group</span>
        </P>
      </ExternalLink>

      {showLines && <Line className="my-3" />}

      <InternalLink href={collectionPath}>
        <P className="hover:text-primary !mb-0 transition-colors">
          <BsArrowRight size={12} className="mr-2 inline" />
          <span>&nbsp;Digital Collection Tracker</span>
        </P>
      </InternalLink>

      <OnClickLink onClick={() => openModal(ModalTypeEnum.PRINTOUTCOLLECTIONTRACKERS)}>
        <P className="hover:text-primary !mb-0 transition-colors">
          <BsArrowRight size={12} className="mr-2 inline" />
          <span>&nbsp;Printout Collection Tracker</span>
        </P>
      </OnClickLink>

      <InternalLink href={collectionGuidePath}>
        <P className="hover:text-primary !mb-0 transition-colors">
          <BsArrowRight size={12} className="mr-2 inline" />
          <span>&nbsp;Collection Guide</span>
        </P>
      </InternalLink>
    </div>
  );
};
